import { render } from "./PPSSetup.vue?vue&type=template&id=e4c3065e"
import script from "./PPSSetup.vue?vue&type=script&lang=js"
export * from "./PPSSetup.vue?vue&type=script&lang=js"

import "./PPSSetup.vue?vue&type=style&index=0&id=e4c3065e&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__